import { defineMessages } from 'react-intl';

export default defineMessages({
    
    cancelPaymenttext1:{
        id: 'billing.common.views.You are terminating automatic payments on this account.',
        defaultMessage: 'You are terminating automatic payments on this account. '
    },
    cancelPaymenttext2:{
        id: 'billing.common.views.please note that',
        defaultMessage: 'Please note that any previously billed invoice amounts will no longer be subject to automatic payments.'
    },
    updateMessage:{
        id: 'billing.common.views.Automatic payments have been updated',
        defaultMessage: 'Automatic payments have been updated. A confirmation e-mail will be sent.'
    },
    setupMessage:{
        id: 'billing.common.views.Automatic payments have been set up',
        defaultMessage: 'Automatic payments have been set up. A confirmation e-mail will be sent.'
    },
    cancelMessage:{
        id: 'billing.common.views.Automatic payments have been Cancelled',
        defaultMessage: 'Automatic payments have been Cancelled. A confirmation e-mail will be sent.'
    }

    
    
});